import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { getPromotionAddFailedCredit } from "../../../services/PromoTemplate/PromoTemplate";

const PromoTemplateIdCreditModal = ({
  templateIdCreditModalVisible,
  setTemplateIdCreditModalVisible,
  promoTemplateIdCreditList = [],
  selectPromotionData = {},
  sendDataToOrdersPageFromFilter
}) => {
  const [sumCount, setSumCount] = useState(0);
  
  useEffect(() => {
    // ✅ Total of all statuses
    // const total = promoTemplateIdCreditList.reduce(
    //   (sum, item) => sum + (item.count || 0),
    //   0
    // );

    // setSumCount(total);

    const counts = {
      sending: 0,
      register: 0,
      failed: 0,
    };

    promoTemplateIdCreditList.forEach((item) => {
      if (counts[item.status] !== undefined) {
        counts[item.status] += item.count; // use item.count instead of +1
      }
    });

    const total = Object.values(counts).reduce((sum, val) => sum + val, 0);

    setSumCount(total)
  }, [promoTemplateIdCreditList]);

  const handlePromotionId = (promotionId) => {
    getPromotionAddFailedCredit(promotionId)
      .then((response) => {
        if (!response?.data?.error && response?.data?.status) {
          setTemplateIdCreditModalVisible(false);
          sendDataToOrdersPageFromFilter(true);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const handleModalClose = () => {
    setTemplateIdCreditModalVisible(false);
  };

  const getCount = (type) =>
    promoTemplateIdCreditList.find((i) => i.status === type)?.count || 0;

  const totalMessages = promoTemplateIdCreditList.reduce(
    (sum, item) => sum + (item.count || 0),
    0
  );

  const sent = getCount("sent");
  const sending = getCount("sending");
  const delivered = getCount("delivered");
  const read = getCount("read");
  const failed = getCount("failed");

  const readPercent = totalMessages
    ? Math.round((read / totalMessages) * 100)
    : 0;

  const unreadPercent = totalMessages
    ? Math.round((delivered / totalMessages) * 100)
    : 0;

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={templateIdCreditModalVisible}
        style={{ width: "50vw" }}
        onHide={handleModalClose}
        content={({ hide }) => (
          <div style={{ background: "#f5f7fa", borderRadius: "12px" }}>

            {/* HEADER */}
            <div className="flex justify-content-between align-items-center px-4 py-3">
              <h3 className="m-0">Performance</h3>
              <Button icon="pi pi-times" text onClick={hide} />
            </div>

            {/* KPI ROW */}
            <div className="flex gap-3 px-4 pb-3 flex-wrap">

              <div className="kpi-box kpi-box2">
                <p>Messages sent</p>
                <h2>{sent}</h2>
              </div>
              <div className="kpi-box kpi-box2">
                <p>Messages sending</p>
                <h2>{sending}</h2>
              </div>
              <div className="kpi-box kpi-box2">
                <p>Messages delivered</p>
                <h2>{delivered + read}</h2>
              </div>

              <div className="kpi-box">
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ flex: 1, minWidth: "120px" }}>
                  <p>Messages read</p>
                  <h2>
                    {read} ({readPercent}%)
                  </h2>
                 
                  </div>
                  <div style={{flex:1, minWidth:"120px"}}>
                  <p>Messages UnRead</p>
                  <h2>
                      {delivered} ({unreadPercent}%)
                  </h2>
                </div>
                </div>
              </div>

              <div className="kpi-box kpi-box2">
                <p>Failed</p>
                <h2>{failed}</h2>
              </div>
              {promoTemplateIdCreditList
                .filter(
                  (item) =>
                    !["sent", "sending", "delivered", "read", "failed"].includes(item.status)
                    // !["delivered", "read", "failed"].includes(item.status)
                )
                .map((item) => (
                  <div className="kpi-box kpi-box2" key={item.id}>
                    {/*<p style={{ textTransform: "capitalize" }}>{item.status}</p>*/}
                    <p style={{ textTransform: "capitalize" }}>Pending</p>
                    <h2>{item.count}</h2>
                  </div>
                ))}
            </div>

            {/* STATUS PILLS */}
            {/*<div className="flex gap-2 px-4 pb-3 flex-wrap">
              {promoTemplateIdCreditList.map((item) => (
                <span
                  key={item.id}
                  className="status-pill"
                  style={{
                    borderColor:
                      item.status === "failed"
                        ? "red"
                        : item.status === "read"
                          ? "#2B70D7"
                          : "#999",
                    color:
                      item.status === "failed"
                        ? "red"
                        : item.status === "read"
                          ? "#2B70D7"
                          : "#555",
                  }}
                >
                  {item.status} - {item.count}
                </span>
              ))}
            </div>*/}

            {/* ACTION */}
            {sumCount > 0 &&
              !selectPromotionData?.failedCreditAdded &&
              selectPromotionData?.status === "DONE" && (
                <div className="px-4 pb-4">
                  <Button
                    label={`Rollback Failed Credit (${sumCount})`}
                    onClick={() => handlePromotionId(selectPromotionData?.id)}
                    className="w-full"
                    style={{
                      background: "#2B70D7",
                      border: "none",
                    }}
                  />
                  <p style={{ color: "red", marginTop: "8px" }}>
                    * Click above button to get credit back
                  </p>
                </div>
              )}
          </div>
        )}
      />
    </div>
  );
};

export default PromoTemplateIdCreditModal;